import PopupPositionEnum from '../enums/PopupPositionEnum';
export var getClickPosition = function (cursorY) {
    var calendarHeight = window.innerHeight;
    var headerHeight = 54 + 12 + 43 + 40;
    var calendarHeightWithoutHeader = calendarHeight - headerHeight;
    var cursorYWithoutHeader = cursorY - headerHeight;
    var thirdPart = calendarHeightWithoutHeader / 3;
    if (cursorYWithoutHeader < thirdPart) {
        return 'top';
    }
    if (cursorYWithoutHeader >= thirdPart &&
        cursorYWithoutHeader <= thirdPart * 2) {
        return 'center';
    }
    if (cursorYWithoutHeader > thirdPart * 2) {
        return 'bottom';
    }
};
export var getPosition = function (weekStarterNumber, dayOfWeek, clickPosition) {
    var marginStyle = 'margin';
    var popoverLocation = PopupPositionEnum.RIGTH_START;
    if (weekStarterNumber === 0) {
        // sunday
        if (dayOfWeek >= 0 && dayOfWeek < 3) {
            marginStyle = 'marginLeft';
            //@ts-ignore
            popoverLocation = getPopupPosition(clickPosition, 'right');
        }
        else {
            marginStyle = 'marginRight';
            //@ts-ignore
            popoverLocation = getPopupPosition(clickPosition, 'left');
        }
    }
    if (weekStarterNumber === 1) {
        // monday
        if (dayOfWeek >= 1 && dayOfWeek < 4) {
            marginStyle = 'marginLeft';
            //@ts-ignore
            popoverLocation = getPopupPosition(clickPosition, 'right');
        }
        else {
            marginStyle = 'marginRight';
            //@ts-ignore
            popoverLocation = getPopupPosition(clickPosition, 'left');
        }
    }
    if (weekStarterNumber === 6) {
        // saturday
        if (dayOfWeek === 6 || (dayOfWeek >= 0 && dayOfWeek < 2)) {
            marginStyle = 'marginLeft';
            //@ts-ignore
            popoverLocation = getPopupPosition(clickPosition, 'right');
        }
        else {
            marginStyle = 'marginRight';
            //@ts-ignore
            popoverLocation = getPopupPosition(clickPosition, 'left');
        }
    }
    return { marginStyle: marginStyle, popoverLocation: popoverLocation };
};
export var getPopupPosition = function (clickPosition, type) {
    if (type === 'right') {
        if (clickPosition === 'top') {
            return PopupPositionEnum.RIGTH_START;
        }
        if (clickPosition === 'center') {
            return PopupPositionEnum.RIGHT;
        }
        if (clickPosition === 'bottom') {
            return PopupPositionEnum.RIGHT_END;
        }
    }
    else {
        if (clickPosition === 'top') {
            return PopupPositionEnum.LEFT_START;
        }
        if (clickPosition === 'center') {
            return PopupPositionEnum.LEFT;
        }
        if (clickPosition === 'bottom') {
            return PopupPositionEnum.LEFT_END;
        }
    }
};
//# sourceMappingURL=popupPositionUtils.js.map